export default function () {
    const newsContainer = document.querySelector('.recent-news');
    if (newsContainer) {    
        fetch('https://blog.lotteryoffice.com.au/wp-json/wp/v2/news?per_page=4&_embed=1&page=1', { method: 'GET' })
            .then(response => response.json())
            .then(response => {
                populateNewsSection(response)
            }).catch((error) => {
                newsContainer.style.display = 'none';
            });
    }

    function populateNewsSection(data) {
        if (!data) {
            newsContainer.style.display = 'none';
            return;
        }
        let newsGrid = document.getElementById('news-winners-grid');
        newsGrid.innerHTML = data.map((news,index) => {
            return `
                <div class="winner-block d-flex">
                    <a href="${news.acf.news_url}/" target="_blank" rel="noreferrer nofollow">
                        <img src="${news.acf.news_image}" alt=" ${news.title.rendered}" loading="lazy" width="255" height="195" />
                        <p class="date">${news.acf.news_provider}, ${news.acf.news_date}</p>
                         <p>
                            ${news.title.rendered}
                        </p>
                        <span>${news.acf.news_label}</span>
                    </a>
             </div>`
        }).join('');
     }
}


// WEBPACK FOOTER //
// ./assets/src/js/classes/news.js